import { render, staticRenderFns } from "./allSearch.vue?vue&type=template&id=01079ebf&scoped=true"
import script from "./allSearch.vue?vue&type=script&lang=js"
export * from "./allSearch.vue?vue&type=script&lang=js"
import style0 from "./allSearch.vue?vue&type=style&index=0&id=01079ebf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01079ebf",
  null
  
)

export default component.exports